import { AnyAsyncThunk } from "@reduxjs/toolkit/dist/matchers";
import React, { useEffect, useState } from "react";
import { Form, Table, Image, Button, Row, Col } from "react-bootstrap";
import { isAdmin, isPermited } from "../../../../features/localStorage";
import Save from "../../../../assets/images/save-line.svg";
import { useAppDispatch } from "../../../../app/hooks";
import { GetinsertCounsellorsListDetails } from "../../../../features/helpandassistance/insertCounsellorslistDetailsSlice";
import { GetCounsellors } from "../../../../features/helpandassistance/counsellorSlice";
import { useForm } from "react-hook-form";

import Delete from "../../../../assets/images/ic-deletebox.svg";
import DeleteBox from "../../../../assets/images/ic-deletebox2.svg";
import DeleteBox1 from "../../../../assets/images/ic-deletebox.svg";
import Add from "../../../../assets/images/ic-add.svg";
import Add2 from "../../../../assets/images/ic-add3.svg";
import { GetdeleteethicsCounsellor } from "../../../../features/helpandassistance/deleteethicsCounsellorSlice";
import swal from "sweetalert";
import { GetdeleteethicsCounsellorDetails } from "../../../../features/helpandassistance/deleteethicsCounsellorDetailsSlice";
import GoBack from "../../../../assets/images/arrow-go-back.svg";
// Messages
const required = "This field is required";
const pattern = "Please insert valid input";
// Error Component
const errorMessage = (error: any) => {
  return <div className="invalid-feedback">{error}</div>;
};

const TableList = ({
  tData,
  isAddSelected = false,
  checkDeleteGroupDetailsId,
  id,
  checkListShow,
  searchData,
  setGroupId,
}: {
  tData: any;
  isAddSelected?: Boolean;
  checkDeleteGroupDetailsId: any;
  id: any;
  checkListShow: any;
  searchData: string;
  setGroupId: any;
}) => {
  const [MasterChecked, setMasterChecked] = useState(false);
  const [SelectedList, setSelectedList] = useState([]);
  const [List, setList] = useState(tData);
  const [tempList, setTempList] = useState(tData);

  const [recordRow, setRecordRow] = useState(false);
  const [saveButton, setSaveButton] = useState(false);
  const [toggleDelete, setToggleDelete] = useState(false);
  const [groupDetailsId, setGroupDetailsId] = useState();

  const [name, setName] = useState("");
  const [email, setemail] = useState("");
  const [designation, setDesignation] = useState("");
  const [location, setlocation] = useState("");
  const [sector, setsector] = useState("");
  const [unit, setunit] = useState("");
  const [empNo, setempNo] = useState("");
  var searchParams = {
    companyId: 0,
    keyword: searchData,
  };
  const dispatch = useAppDispatch();
  const { register, handleSubmit, errors } = useForm();
  const onSubmit = async (event: any) => {
    // event.preventDefault();
    var postdata = {
      emailId: email,
      designation: designation,
      location: location,
      name: name,
      no: parseInt(empNo),
      sector: sector,
      unit: unit,
      eng_ethics_counsellor_group_id: id,
    };
    var data = {
      data: postdata,
      id: id,
    };
    await dispatch(GetinsertCounsellorsListDetails(data));
    var getData = {
      companyId: 0,
      keyword: "*",
    };
    await dispatch(GetCounsellors(getData));
    // await window.location.reload()
    setemail("");
    setDesignation("");
    setlocation("");
    setName("");
    setempNo("");
    setsector("");
    setunit("");
    setRecordRow(false);
  };

  const onMasterCheck = async (e: React.ChangeEvent<HTMLInputElement>) => {
    //await checkDeleteGroupDetailsId(List.map((e:any) => e.id))
    let newList = tempList.map((obj: any) =>
      Object.assign({}, obj, { selected: e.target.checked })
    );
    //console.log(List.map((e:any) => e.id),"onMasterCheck")
    setMasterChecked(e.target.checked);
    setList(newList);
    setTempList(newList);
    await setSelectedList(newList.filter((e: any) => e.selected));
    await setGroupDetailsId(newList.map((e: any) => e.id));
  };

  const newMappedList = (data: any, item: any, checked: boolean) => {
    //console.log(data,item,checked, "newMapedList")
    let newData = data.map((obj: any) => {
      let selected = false; //obj.selected
      if (obj.id === item.id) {
        selected = checked;
      } else {
        selected = obj?.selected ? obj.selected : false;
      }
      return {
        ...obj,
        selected: selected,
      };
    });
    return newData;
  };

  const onItemCheck = async (
    e: React.ChangeEvent<HTMLInputElement>,
    item: any
  ) => {
    //console.log(item, "onItemCheck")
    let newList = newMappedList(tempList, item, e.target.checked);

    const totalItems = newList.length;
    const totalCheckedItems = newList.filter((e: any) => e.selected).length;

    setMasterChecked(totalItems === totalCheckedItems);
    setList(newList);
    setTempList(newList);
    //console.log(List.filter((e:any) => e.selected),"List.filter((e:any) => e.selected)")
    setSelectedList(newList.filter((e: any) => e.selected));
    await setGroupDetailsId(newList.map((e: any) => e.id));
    // let filtredRecords: any[] = newList.filter((e: any) => e.selected);
    // let newArray = filtredRecords.map({id} => id);

    // setGroupDetailsId([...newArray]);
  };

  const getSelectedRows = () => {
    setSelectedList(List.filter((e: any) => e.selected));
  };
  useEffect(() => {
    // alert(checkListShow)
    async function fetchLocationData() {
      //console.log(SelectedList,"SelectedListSelectedList");
      await checkDeleteGroupDetailsId(SelectedList.map((e: any) => e.id));
    }
    fetchLocationData();
    setGroupId(id);
  }, [SelectedList, groupDetailsId, tData]);
  const onAddRecord = () => {
    setRecordRow(true);
  };
  const onDeleteGroupDetails = async () => {
    swal({
      title: "Are you sure delete record?",
      text: "Once deleted, you will not be able to recover this record",
      icon: "warning",
      dangerMode: true,
    }).then(async (willDelete: any) => {
      if (willDelete) {
        swal(" Your record has been deleted!", {
          icon: "success",
        });
        let toBeDeleteArray = SelectedList.map((obj: any) => {
          return obj?.id;
        });
        let tobeDeleteString = toBeDeleteArray.join(",");
        await dispatch(GetdeleteethicsCounsellorDetails(tobeDeleteString));
        await dispatch(GetCounsellors(searchParams));
        // await window.location.reload()
      } else {
        swal("Your record is safe!");
      }
    });
  };
  const onDeleteGroup = () => {
    var data = {
      id: id,
    };
    swal({
      title: "Are you sure delete record?",
      text: "Once deleted, you will not be able to recover this record",
      icon: "warning",
      dangerMode: true,
    }).then(async (willDelete: any) => {
      if (willDelete) {
        swal(" Your record has been deleted!", {
          icon: "success",
        });
        await dispatch(GetdeleteethicsCounsellor(data));
        await dispatch(GetCounsellors(searchParams));
        await window.location.reload();
      } else {
        swal("Your record is safe!");
      }
    });
  };
  const resetSearch = async () => {
    alert();
    await dispatch(GetCounsellors(searchParams));
  };
  return (
    <>
      {isPermited(9, 2) && (
        <>
          {checkListShow === false ? (
            <Row>
              {saveButton !== true ? (
                <>
                  <Col sm={6}>
                    <span style={styles.deletecompany}>
                      <a style={styles.link} onClick={onDeleteGroup}>
                        <Image src={Delete} /> DELETE COMPANY
                      </a>
                    </span>
                  </Col>
                  {/* <Col sm={2} className="text-right">  <span style={styles.link} onClick={resetSearch}>
                      <Image src={GoBack} /> RESET SEARCH
                    </span></Col> */}
                  <Col
                    sm={1}
                    className="ms-auto mb-3"
                    onClick={() => setToggleDelete(!toggleDelete)}
                  >
                    <Image src={Add2} onClick={onAddRecord} />
                    {groupDetailsId === undefined ? (
                      <Image
                        src={DeleteBox}
                        onClick={onDeleteGroupDetails}
                        className="float-end logo-img"
                        alt="Logo1"
                      />
                    ) : (
                      <Image
                        src={DeleteBox1}
                        onClick={onDeleteGroupDetails}
                        className="float-end logo-img"
                        alt="Logo"
                      />
                    )}
                  </Col>
                </>
              ) : null}
            </Row>
          ) : null}
        </>
      )}
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="grid">
          <div className="grid-container">
            <Table style={styles.border} responsive>
              <tr>
                {isPermited(9, 2) && (
                  <>
                    {checkListShow === false ? (
                      <th className="py-3 ps-3" style={styles.tableHeading}>
                        <Form.Check
                          type="checkbox"
                          checked={MasterChecked}
                          id="mastercheck"
                          onChange={(e) => onMasterCheck(e)}
                        />
                      </th>
                    ) : null}
                  </>
                )}
                <th className="py-3 ps-3" style={styles.tableHeading}>
                  Sr. No.
                </th>
                <th className="py-3 ps-3" style={styles.tableHeading}>
                  EMP No.
                </th>
                <th className="py-3 ps-3" style={styles.tableHeading}>
                  Name
                </th>
                <th className="py-3 ps-3" style={styles.tableHeading}>
                  Designation
                </th>
                <th className="py-3 ps-3" style={styles.tableHeading}>
                  Location
                </th>
                <th className="py-3 ps-3" style={styles.tableHeading}>
                  Sector
                </th>
                <th className="py-3 ps-3" style={styles.tableHeading}>
                  Unit
                </th>
                <th className="py-3 ps-3" style={styles.tableHeading}>
                  Email ID
                </th>
              </tr>

              <>
                {recordRow === true ? (
                  <>
                    <tr style={styles.border}>
                      {isPermited(9, 2) && (
                        <td
                          className="py-3 ps-3"
                          style={styles.tableContents}
                        ></td>
                      )}
                      <td className="py-3 ps-3" style={styles.tableContents}>
                        {" "}
                      </td>
                      <td className="py-3 ps-3" style={styles.tableContents}>
                        <div className="helpfloating-label-group">
                          <input
                            type="text"
                            name="empname"
                            value={empNo}
                            ref={register({
                              required: true,
                              pattern: /^[0-9]*$/,
                            })}
                            className="helptextstyle"
                            onChange={(
                              ev: React.ChangeEvent<HTMLInputElement>
                            ): void => setempNo(ev.target.value)}
                          />
                          <label className="helpfloating-label">
                            EMP No. <span style={styles.star}> * </span>
                          </label>
                        </div>
                        {errors.empname &&
                          errors.empname.type === "required" &&
                          errorMessage(required)}
                        {errors.empname &&
                          errors.empname.type === "pattern" &&
                          errorMessage(pattern)}
                      </td>
                      <td className="py-3 ps-3" style={styles.tableContents}>
                        <div className="helpfloating-label-group">
                          <input
                            type="text"
                            name="name"
                            value={name}
                            ref={register({
                              required: true,
                            })}
                            className="helptextstyle"
                            onChange={(
                              ev: React.ChangeEvent<HTMLInputElement>
                            ): void => setName(ev.target.value)}
                          />
                          <label className="helpfloating-label">
                            Name <span style={styles.star}> * </span>
                          </label>
                        </div>
                        {errors.name &&
                          errors.name.type === "required" &&
                          errorMessage(required)}
                      </td>
                      <td className="py-3 ps-3" style={styles.tableContents}>
                        <div className="helpfloating-label-group">
                          <input
                            type="text"
                            name="Designation"
                            value={designation}
                            ref={register({
                              required: true,
                            })}
                            className="helptextstyle"
                            onChange={(
                              ev: React.ChangeEvent<HTMLInputElement>
                            ): void => setDesignation(ev.target.value)}
                          />
                          <label className="helpfloating-label">
                            Designation <span style={styles.star}> * </span>
                          </label>
                        </div>
                        {errors.Designation &&
                          errors.Designation.type === "required" &&
                          errorMessage(required)}
                      </td>
                      <td className="py-3 ps-3" style={styles.tableContents}>
                        <div className="helpfloating-label-group">
                          <input
                            type="text"
                            name="Location"
                            value={location}
                            ref={register({
                              required: true,
                            })}
                            className="helptextstyle"
                            onChange={(
                              ev: React.ChangeEvent<HTMLInputElement>
                            ): void => setlocation(ev.target.value)}
                          />
                          <label className="helpfloating-label">
                            Location <span style={styles.star}> * </span>
                          </label>
                        </div>
                        {errors.Location &&
                          errors.Location.type === "required" &&
                          errorMessage(required)}
                      </td>
                      <td className="py-3 ps-3" style={styles.tableContents}>
                        <div className="helpfloating-label-group">
                          <input
                            type="text"
                            value={sector}
                            name="Sector"
                            ref={register({
                              required: true,
                            })}
                            className="helptextstyle"
                            onChange={(
                              ev: React.ChangeEvent<HTMLInputElement>
                            ): void => setsector(ev.target.value)}
                          />
                          <label className="helpfloating-label">
                            Sector <span style={styles.star}> * </span>
                          </label>
                        </div>
                        {errors.Sector &&
                          errors.Sector.type === "required" &&
                          errorMessage(required)}
                      </td>
                      <td className="py-3 ps-3" style={styles.tableContents}>
                        <div className="helpfloating-label-group">
                          <input
                            type="text"
                            name="Unit"
                            value={unit}
                            ref={register({
                              required: true,
                            })}
                            className="helptextstyle"
                            onChange={(
                              ev: React.ChangeEvent<HTMLInputElement>
                            ): void => setunit(ev.target.value)}
                          />
                          <label className="helpfloating-label">
                            Unit <span style={styles.star}> * </span>
                          </label>
                        </div>
                        {errors.Unit &&
                          errors.Unit.type === "required" &&
                          errorMessage(required)}
                      </td>
                      <td className="py-3 ps-3" style={styles.tableContents}>
                        <div className="helpfloating-label-group">
                          <input
                            type="email"
                            value={email}
                            name="EmailID"
                            ref={register({
                              required: true,
                              pattern: /^\S+@\S+$/i,
                            })}
                            className="helptextstyle"
                            onChange={(
                              ev: React.ChangeEvent<HTMLInputElement>
                            ): void => setemail(ev.target.value)}
                          />
                          <label className="helpfloating-label">
                            Email ID <span style={styles.star}> * </span>
                          </label>
                        </div>
                        {errors.EmailID &&
                          errors.EmailID.type === "required" &&
                          errorMessage(required)}
                        {errors.EmailID &&
                          errors.EmailID.type === "pattern" &&
                          errorMessage(pattern)}
                      </td>
                      <td className="py-3 ps-3" style={styles.tableContents}>
                        <Button
                          className="mb-2"
                          type="submit"
                          style={styles.button}
                        >
                          {" "}
                          SAVE
                        </Button>
                      </td>
                    </tr>
                  </>
                ) : null}
              </>

              {tData.map((val: any, index: any) => {
                return (
                  <>
                    <tr style={styles.border}>
                      {isPermited(9, 2) && (
                        <>
                          {checkListShow === false ? (
                            <td
                              className="py-3 ps-3"
                              style={styles.tableContents}
                            >
                              <Form.Check
                                type="checkbox"
                                checked={val.selected}
                                id="rowcheck{val.id}"
                                onChange={(e) => onItemCheck(e, val)}
                              />
                            </td>
                          ) : null}
                        </>
                      )}
                      <td className="py-3 ps-3" style={styles.tableContents}>
                        {index + 1}
                      </td>
                      <td className="py-3 ps-3" style={styles.tableContents}>
                        {val.employeeId}
                      </td>
                      <td className="py-3 ps-3" style={styles.tableContents}>
                        {val.name}
                      </td>
                      <td className="py-3 ps-3" style={styles.tableContents}>
                        {val.designation}
                      </td>
                      <td className="py-3 ps-3" style={styles.tableContents}>
                        {val.location}
                      </td>
                      <td className="py-3 ps-3" style={styles.tableContents}>
                        {val.sector}
                      </td>
                      <td className="py-3 ps-3" style={styles.tableContents}>
                        {val.unit}
                      </td>
                      <td className="py-3 ps-3" style={styles.tableContents}>
                        {val.emailId}
                        <br />
                      </td>
                    </tr>
                  </>
                );
              })}
            </Table>
          </div>
        </div>
      </form>
    </>
  );
};
const styles: any = {
  button: {
    padding: "8px 30px",
    fontFamily: "Saira",
    fontSize: "12px",
    fontWeight: 400,
    fontStretch: "normal",
    fontStyle: "normal",
    borderRadius: "0",
    backgroundColor: "#e31837",
    letterSpacing: "normal",
    border: "0px",
    float: "right",
    marginTop: "8px",
  },
  star: { color: "#e31837" },
  textfield: {
    width: "60%",
  },
  link: {
    fontFamily: "Saira",
    fontSize: "12px",
    fontWeight: "600",
    color: "#e31837",
    lineHeight: "2",
    textTransform: "uppercase",
    textDecoration: "none",
  },
  save: { color: "#e31837", fontSize: "12px" },
  divWhite: {
    backgroundColor: "#fffff",
    padding: "24px",
  },
  tableHeading: {
    fontFamily: "Saira",
    fontSize: "12px",
    fontWeight: "600",
  },
  tableContents: {
    fontFamily: "Saira",
    fontSize: "12px",
    fontWeight: "normal",
  },
  border: {
    border: "solid 1px #e4e4e4",
  },
};
export default TableList;
